import {
  Box,
  Button,
  CircularProgress,
  LinearProgress,
  Rating,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Panelimg from "../../../Assets/provider.jpeg";
import { useSnackbar } from "notistack";
import { useNavigate, useLocation } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useAuth } from "../../../AuthContext/AuthContext";
import { useParams } from "react-router-dom";
import Avatar from "@mui/material/Avatar";

const Details = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const location = useLocation();
  const [description, setdescription] = useState("");
  const [subject, setsubject] = useState("");
  const [value, setValue] = useState(0);
  const [isloadingreting, setisloadingreting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { serviceid } = useParams();

  const [ratingPercentages, setRatingPercentages] = useState([]);
  const [averageRating, setAverageRating] = useState("2.6");
  const baseApi = api_Routes.Providers.getServiceById(serviceid);
  const [isLoading, setIsLoading] = useState(true);
  const [Review, setReview] = useState([]);
  const [Service, setService] = useState({});
  const serviceIdRef = useRef(null);
  useEffect(() => {
    get_Service();
  }, []);
  const get_Service = async () => {
    let url = `${baseApi}`;
    const { response, message } = await Helper.Get({
      url: url,
      hasToken: true,
    });
    if (response && response.success) {
      serviceIdRef.current = response?.data?.id;

      setIsLoading(false);
      setService({
        name: response?.data?.name,
        rate_per_1000: response?.data?.rate_per_1000,
        category: response?.data?.category,
        id_service_for_panel: response?.data?.id_service_for_panel,
        min_order: response?.data?.min_order,
        max_order: response?.dat?.max_order,
        count_review: response?.data.count_review,
      });
      setReview([]);
      response.data.reviews?.forEach((ele) => {
        setReview((prev) => [
          ...prev,
          {
            id: ele.id,
            username: ele.user_name,
            rate: ele.rate,
            description: ele.description,
            subject: ele.subject,
            user_photo: ele.user_photo,
            created_at: ele.created_at,
          },
        ]);
      });
      const percentages = response?.data?.rate;
      setRatingPercentages([
        { label: "5 Stars", value: percentages.percentage_rate_5 },
        { label: "4 Stars", value: percentages.percentage_rate_4 },
        { label: "3 Stars", value: percentages.percentage_rate_3 },
        { label: "2 Stars", value: percentages.percentage_rate_2 },
        { label: "1 Star", value: percentages.percentage_rate_1 },
      ]);
      setAverageRating(response?.data?.rate?.avg || 0);
    } else {
      setIsLoading(false);
      enqueueSnackbar(message, { variant: "error" });
    }
  };
  const handleButtonClick = async () => {
    if (!auth) {
      enqueueSnackbar("please login first ", { variant: "warning" });
      navigate("/login", { state: { from: location } });
    } else {
      await handleAddRating();
    }
  };

  const handleAddRating = async () => {
    if (!value || !description || !subject) {
      setisloadingreting(false);
      enqueueSnackbar("All fields are required", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      return;
    }

    setisloadingreting(true);
    const service_id = serviceIdRef.current
      ? String(serviceIdRef.current)
      : null;

    if (!service_id) {
      console.error("Invalid service_id");
      return;
    }

    const { response, message } = await Helper.Post({
      url: api_Routes.Providers.addReviewsService,
      data: {
        rate: value,
        service_id: service_id,
        description: description,
        subject: subject,
      },
      hasToken: true,
    });

    if (response) {
      setisloadingreting(false);
      get_Service();
      setValue(null);
      setsubject("");
      setdescription("");
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setisloadingreting(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress sx={{ color: "#425460" }} />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              padding: {
                xs: "30px",
                sm: "30px 30px 30px 40px",
                md: "30px",
                lg: "30px 80px",
              },
              background: "#D2E2EC",
            }}
            className="offer-details-container"
          >
            {/* PanelsDetails Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: "50px", md: "30px" },
                alignItems: { xs: "center", md: "normal" },
                // justifyContent: "center"
              }}
            >
              <Box
                sx={{
                  background: "#FFFFFF",
                  padding: "50px 20px",
                  borderRadius: "25px",
                  width: { xs: "100%", md: "600px" },
                  height: "400px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "20px",
                    lineHeight: "24px",
                    color: "black",
                  }}
                >
                  {Service.name}
                </Typography>
                <Typography
                  sx={{
                    marginBlock: "20px",
                    fontWeight: "300",
                    fontSize: "16px",
                    color: "#474747",
                  }}
                >
                  Total Reviews ({Service.count_review})
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly",
                    height: "80%",
                    width: { xs: "100%", md: "90%" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "15px",
                        color: "#474747",
                      }}
                    >
                      Panel
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#303030",
                      }}
                    >
                      https://smmfollows.com
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "15px",
                        color: "#474747",
                      }}
                    >
                      ID
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#303030",
                      }}
                    >
                      {Service.id_service_for_panel}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "15px",
                        color: "#474747",
                      }}
                    >
                      Rate
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#303030",
                      }}
                    >
                      {Service.rate_per_1000}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "15px",
                        color: "#474747",
                      }}
                    >
                      Limit
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#303030",
                      }}
                    >
                      Min: {Service.min_order} / Max: {Service.max_order}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "600",
                        fontSize: "14px",
                        lineHeight: "15px",
                        color: "#474747",
                      }}
                    >
                      Category
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "12px",
                        color: "#303030",
                      }}
                    >
                      {Service.category}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  flexDirection: "column",
                  width: { xs: "100%", md: "60%" },
                  gap: { xs: "30px", md: 0 },
                }}
              >
                <div
                  className="img-container"
                  style={{
                    height: "250px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  <img
                    src={Panelimg}
                    alt="Panel"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    sx={{
                      fontWeight: "700",
                      fontSize: { xs: "14px", lg: "20px" },
                      lineHeight: "30px",
                      textAlign: "center",
                      borderRadius: "10px",
                      padding: { xs: "10px 30px", lg: "10px 70px" },
                      background: "#3F78E0",

                      color: "#F1F5FD",
                      boxShadow:
                        "0px 5px 5px #00000040, inset 4px 7px 5px #FFFFFF30",
                      "&:hover": {
                        background: "#2E5DBA", // Optional: Darken background on hover
                      },
                    }}
                    // onClick={() => window.open(Panel.url, "_blank")}
                  >
                    Visit Provider Website
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ marginLeft: "6px" }}
                    >
                      <g clipPath="url(#clip0_179_2758)">
                        <path
                          d="M9.41487 3.61514H6.91015C5.3515 3.61514 4.5716 3.61514 3.97628 3.91848C3.45262 4.18529 3.02718 4.61073 2.76037 5.1344C2.45703 5.72971 2.45703 6.50962 2.45703 8.06826V18.6438C2.45703 20.2024 2.45703 20.9814 2.76037 21.5766C3.02718 22.1003 3.45262 22.5265 3.97628 22.7932C4.57102 23.0963 5.34997 23.0963 6.90557 23.0963H17.4897C19.0452 23.0963 19.8231 23.0963 20.4178 22.7932C20.9415 22.5265 21.3684 22.0999 21.6351 21.5762C21.9382 20.9815 21.9382 20.2034 21.9382 18.6478V16.1388M23.3297 9.18119V2.22363M23.3297 2.22363H16.3722M23.3297 2.22363L13.5891 11.9642"
                          stroke="white"
                          strokeWidth="3.03603"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_179_2758">
                          <rect width="25" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{ padding: { xs: "30px", sm: "30px 50px", lg: "30px 80px" } }}
          >
            <Typography
              sx={{
                fontSize: { xs: "25px", md: "35px" },
                lineHeight: "40px",
                fontWeight: "700",
                color: "#474747",
                marginBottom: "20px",
                textAlign: { xs: "center", sm: "center", md: "start" },
              }}
            >
              Feedback & Reviews
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "flex-start",
                gap: "60px",
              }}
            >
              <Box
                sx={{
                  background: "#F8FAFF",
                  width: { xs: "100%", md: "50%" },
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "-4px 4px 4px #00000040",
                  border: "1px solid #959595",
                  borderRadius: "25px",
                  maxHeight: "700px",
                  overflow: "hidden", // Ensures rounded corners clip the content
                }}
              >
                {/* Inner scrolling container */}
                <Box
                  sx={{
                    overflow: "auto", // Enables scrolling
                    height: "100%",
                    "&::-webkit-scrollbar": {
                      width: "6px", // Width of the scrollbar
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#B9B9B9",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#3F78E0", // Color of the scrollbar thumb
                      borderRadius: "10px", // Rounded corners for the thumb
                    },
                  }}
                >
                  {Review.length > 0 ? (
                    Review.map((ele) => (
                      <Box
                        key={ele.id}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "30px",
                          gap: "10px",
                          alignItems: { xs: "flex-start", md: "flex-start" },
                          marginBottom: "36px",
                          borderBottom: "1px solid #D9D9D9",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Avatar
                            src={ele.user_photo}
                            alt="person"
                            sx={{
                              border: "1px solid #959595",
                              width: "60px",
                              height: "60px",
                            }}
                          />
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "500",
                                fontSize: "25px",
                                lineHeight: "30px",
                                color: "#474747",
                              }}
                            >
                              {ele.username}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#959595",
                                lineHeight: "25px",
                                fontSize: "20px",
                                fontWeight: "500",
                              }}
                            >
                              {ele.created_at}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "6px",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#474747",
                            }}
                          >
                            {ele.subject}
                          </Typography>
                          |
                          <Typography
                            sx={{
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#959595",
                              fontWeight: "600",
                            }}
                          >
                            ({ele.rate})
                          </Typography>
                          <Rating
                            value={ele.rate}
                            readOnly
                            sx={{ fontSize: "1.5rem" }}
                          />
                        </Box>
                        <Box sx={{ marginBottom: "20px" }}>
                          <Typography
                            sx={{
                              fontWeight: "400",
                              fontSize: "20px",
                              lineHeight: "26px",
                              color: "#474747",
                            }}
                          >
                            {ele.description}
                          </Typography>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ padding: "20px" }}>
                      No reviews yet
                    </Typography>
                  )}
                </Box>
              </Box>

              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                {/* Ratings Statistics Header */}
                <Box mb={4}>
                  <Typography
                    sx={{
                      fontWeight: "500",
                      color: "#474747",
                      fontSize: "28px",
                      lineHeight: "35px",
                      textAlign: { xs: "center", md: "normal" },
                    }}
                  >
                    Ratings Statistics
                  </Typography>
                  <Typography
                    sx={{
                      color: "#959595",
                      lineHeight: "30px",
                      fontSize: "24px",
                      fontWeight: "500",
                      marginTop: "10px",
                      textAlign: { xs: "center", md: "start" },
                    }}
                  >
                    {Number.isFinite(averageRating)
                      ? averageRating.toFixed(2)
                      : "0.00"}{" "}
                    out of 5.00
                  </Typography>
                </Box>

                {/* Display Rating Percentages */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  {ratingPercentages.map((item, index) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                      mb={1}
                      key={index}
                    >
                      <Typography
                        sx={{
                          fontWeight: "500",
                          fontSize: "24px",
                          lineHeight: "30px",
                          color: "#474747",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Box width="100%" mr={1} ml={1}>
                          <LinearProgress
                            variant="determinate"
                            value={item.value}
                            sx={{
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#ECA601", // Color of the filled progress
                              },
                              backgroundColor: "#B9B9B9", // Color of the unfilled track
                              height: 10, // Optional: adjust height if desired
                              borderRadius: "5px", // Optional: rounded corners
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "20px",
                            lineHeight: "25px",
                            color: "#959595",
                          }}
                        >
                          {`${item.value.toFixed(1)}%`}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
          <div>
            <Box
              sx={{ padding: { xs: "30px", sm: "30px 50px", lg: "30px 80px" } }}
            >
              <Box
                sx={{
                  background: "#EBF2FF",
                  padding: "50px 10px",
                  borderRadius: "25px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: { xs: "20px", md: "35px" },
                    lineHeight: "40px",
                    color: "#474747",
                    textAlign: "center",
                  }}
                >
                  Add your own review
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-around",
                    alignItems: "center",
                    padding: {
                      xs: "30px 50px",
                      sm: "30px 10px",
                      md: "30px 5px",
                    },
                    gap: { xs: "20px", sm: 0 },
                  }}
                >
                  <Box sx={{ width: { xs: "100%", sm: "45%" } }}>
                    <Typography
                      sx={{
                        marginBottom: "10px",
                        fontSize: "22px",
                        lineHeight: "25px",
                        fontWeight: "500",
                        color: "#474747",
                      }}
                    >
                      Review description
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      multiline
                      minRows={4} // sets the initial height
                      InputLabelProps={{
                        style: { color: "#434343", fontSize: "13px" },
                      }}
                      value={description}
                      onChange={(e) => {
                        setdescription(e.target.value);
                      }}
                      name="description"
                      placeholder="Add Your Comment About The Review.."
                      sx={{
                        background: "white",
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "none", // removes the outline
                          },
                          "& textarea": {
                            // target textarea styling
                            borderRadius: "10px",
                            padding: "10px",
                          },
                        },
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100%", sm: "40%" },
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          marginBottom: "10px",
                          fontSize: "22px",
                          lineHeight: "25px",
                          fontWeight: "500",
                          color: "#474747",
                        }}
                      >
                        Subject Title
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: "#434343", fontSize: "13px" },
                        }}
                        name="  Subject Title"
                        value={subject}
                        onChange={(e) => {
                          setsubject(e.target.value);
                        }}
                        placeholder="Add Your Comment About The Review ..."
                        sx={{
                          background: "white",
                          borderRadius: "10px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              border: "none", // removes the outline
                            },
                            "& input": {
                              borderRadius: "10px",
                              padding: "10px ",
                            },
                          },
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          marginBottom: "10px",
                          fontSize: "22px",
                          lineHeight: "25px",
                          fontWeight: "500",
                          color: "#474747",
                        }}
                      >
                        Your Rating
                      </Typography>
                      <Rating
                        size="large"
                        name="simple-controlled"
                        value={value}
                        onChange={(event, newValue) => {
                          setValue(newValue);
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      whiteSpace: "nowrap",
                      background: "#ECA601",
                      padding: "5px 50px",
                      borderRadius: "10px",
                      // Adding inner shadow using a pseudo-element
                      color: "#F1F5FD",
                      position: "relative",
                      lineHeight: "38px",
                      overflow: "hidden",
                      fontWeight: "700",
                      fontSize: "28px",
                      boxShadow: "0px 3px 3px #00000040", // Outer shadow
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: "0 20px 20px 0",
                        background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                        filter: "blur(4px)",
                        zIndex: 1,
                      },
                      "&:hover:before": {
                        background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                      },
                    }}
                    onClick={handleButtonClick}
                  >
                    {isloadingreting ? (
                      <CircularProgress size={22} sx={{ color: "white" }} />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Box>
              </Box>
            </Box>
          </div>
        </>
      )}
    </>
  );
};
export default Details;
